import { createContext, useState, useEffect, ReactNode } from 'react'

import { SnackData } from '../interfaces/SnackData'
import { getBurggers, getDrinks, getIceCreams, getPizzas } from '../services/api'

interface SnackContextProps {
  burggers: SnackData[]
  pizzas: SnackData[]
  drinks: SnackData[]
  iceCreams: SnackData[]
}

interface SnackProviderProps {
  children: ReactNode
}
export const SnackContext = createContext({} as SnackContextProps)

export function SnackProvider({ children }: SnackProviderProps) {
  const [burggers, setBurggers] = useState<SnackData[]>([])
  const [pizzas, setPizzas] = useState<SnackData[]>([])
  const [drinks, setDrinks] = useState<SnackData[]>([])
  const [iceCreams, setIceCreams] = useState<SnackData[]>([])

  useEffect(() => {
    ;(async () => {
      try {
        const burggerRequest = getBurggers()
        const pizzasRequest = getPizzas()
        const drinksRequest = getDrinks()
        const iceCreamsRequest = getIceCreams()

        const requests = [burggerRequest, pizzasRequest, drinksRequest, iceCreamsRequest]

        const [
          { data: burggerResponse },
          { data: pizzasResponse },
          { data: drinksResponse },
          { data: iceCreamsResponse },
        ] = await Promise.all(requests)

        setBurggers(() => burggerResponse)
        setPizzas(() => pizzasResponse)
        setDrinks(() => drinksResponse)
        setIceCreams(() => iceCreamsResponse)
      } catch (error) {
        console.log(error)
      }
    })()
  }, [])

  return (
    <SnackContext.Provider value={{ burggers, pizzas, drinks, iceCreams }}>
      {children}
    </SnackContext.Provider>
  )
}
